// initial state
const state = {
    cancelTokenArr: [] // 取消请求token数组
}

// getters
const getters = {
}

// mutations
const mutations = {
    pushToken(state, payload) {
        state.cancelTokenArr.push(payload.cancelToken)
    },
    clearToken({ cancelTokenArr }) {
        cancelTokenArr.forEach(item => {
            item('路由跳转取消请求')
        })
        cancelTokenArr = []
    }
}
// actions
const actions = {
}

export default {
    state,
    getters,
    actions,
    mutations
}
